import {createApi} from "@reduxjs/toolkit/query/react";
import customFetchBase from "../../../principal/customFetchBase";

export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: customFetchBase,
  tagTypes: ["Users"],
  endpoints: () => ({}),
});
